import * as React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
	Container,
	TextField,
	Card,
	Button,
	TableContainer,
	Table,
	TableHead,
	TableCell,
	TableBody,
	TableRow,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Modal,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@mui/material";
import axios from "axios";
import { AccessContext } from "../../constant/accessContext";
import {
	getLookupData,
	setLookupData,
	delLookupData,
	editFinList,
	addFin,
	getFinList,
} from "../../constant/url";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component={"div"}>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		"aria-controls": `full-width-tabpanel-${index}`,
	};
}
const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
};

export default function LookupEntry() {
	const access = React.useContext(AccessContext).authID;
	const theme = useTheme();
	const [value, setValue] = React.useState(0);
	const [lookUpList, setLookupList] = React.useState([]);
	const [lkpCat, setLkpCat] = React.useState("pipeType");
	const [editValue, setEditValue] = React.useState("");
	const [editSubValue, setEditSubValue] = React.useState("");
	const [selectedRowId, setSelectedRowId] = React.useState([]);

	const [finCode, setFinCode] = React.useState("");

	const handleChange = (event, newValue) => {
		setValue(newValue);
		setLkpCat(event.target.name);
	};

	const handleChangeIndex = (index) => {
		setValue(index);
	};

	function TabContent(props) {
		const index = props.index;
		const [value, setValue] = React.useState("");
		const [subValue, setSubValue] = React.useState("");

		const lkpList = lookUpList[lkpCat];
		return (
			<Card id={"card" + index}>
				<div id={"main" + index}>
					<h3 id={"h3" + index}>Add look up value</h3>
					<div id={"body-div" + index} className="row">
						{lkpCat !== "coverDetail" && (
							<div id={"lkuvaluediv" + index} className="col-4">
								<TextField
									label="Look up Value"
									key={"lkpvalue" + index}
									name="lkpvalue"
									autoComplete="lkpvalue"
									required
									fullWidth
									value={value}
									onChange={(e) => {
										setValue(e.target.value);
									}}
								/>
							</div>
						)}
						{lkpCat === "coverDetail" && (
							<div id={"divrow " + index} className="row">
								<div id={"card" + index} className="col-4">
									<FormControl fullWidth>
										<InputLabel id="coverType-label">Cover Type</InputLabel>
										<Select
											labelId="coverType-label"
											id={"coverType-select" + index}
											label="Cover Type"
											value={value}
											onChange={(event) => setValue(event.target.value)}
											key={"ct" + index}
										>
											{lookUpList["coverType"]?.map((item) => {
												return (
													<MenuItem value={item.id}>{item.lkp_value}</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								</div>
								<div className="col-4">
									<TextField
										label="Sub Look up Value"
										key={"sublkpvalue" + index}
										name="lkpvalue"
										autoComplete="lkpvalue"
										required
										fullWidth
										value={subValue}
										onChange={(e) => {
											setSubValue(e.target.value);
										}}
									/>
								</div>
							</div>
						)}
						<div className="col-4">
							<Button
								type="submit"
								key={"btn" + index}
								variant="contained"
								id={"button" + index}
								onClick={() => handleSubmit(value, subValue)}
							>
								Update
							</Button>
						</div>
					</div>
					<div className="mt-2">
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>Lookup Name</TableCell>
										{lkpCat === "coverDetail" && (
											<TableCell>Sub Lookup Name</TableCell>
										)}
										<TableCell>Action</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{lkpList?.map((item) => {
										return (
											<TableRow>
												<TableCell>{item.lkp_value}</TableCell>
												{lkpCat === "coverDetail" && (
													<TableCell>{item.sublkp_val}</TableCell>
												)}
												<TableCell>
													<Tooltip
														title="Edit"
														id={"tooledit" + index + "-" + item.id}
														color="info"
													>
														<IconButton
															id={"edit-button" + index + "-" + item.id}
															data-bs-toggle="modal"
															data-bs-target="#staticBackdrop"
															key={"icbtnedit" + index}
															onClick={() => {
																setSelectedRowId(item.id);
																setEditValue(item.lkp_value);
																setEditSubValue(item.sublkp_val);
															}}
														>
															<CreateRoundedIcon />
														</IconButton>
													</Tooltip>
													<Tooltip
														title="Delete"
														id={"tooldelete" + index + "-" + item.id}
													>
														<IconButton
															color="error"
															onClick={() => handleDelete(item.id)}
															key={"icbtndel" + index}
														>
															<DeleteIcon />
														</IconButton>
													</Tooltip>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
				</div>
			</Card>
		);
	}

	function TableFins(props) {
		const { dataList, setSelectedRowId, setValue, setSubValue, index, setFinCode, setStatus } = props;
		return (
			<>
				<TableHead id={"thead" + index}>
					<TableRow>
						<TableCell>Code</TableCell>
						<TableCell>Description</TableCell>
						<TableCell>Status</TableCell>
						<TableCell>Action</TableCell>
					</TableRow>
				</TableHead>
				<TableBody id={"tbody" + index}>
					{dataList?.map((item) => (
						<TableRow key={"row" + index + "-" + item.id}>
							<TableCell>{item.code}</TableCell>
							<TableCell>{item.description}</TableCell>
							<TableCell>
								{item.status === "1" ? "Active" : "Inactive"}
							</TableCell>

							<TableCell>
								<Tooltip title="Edit">
									<IconButton
										onClick={() => {
											setSelectedRowId(item.id);
											setFinCode(item.code);
											setSubValue(item.description);
											setStatus(item.status === "1" ? "1" : "0");
											setOpen(true)
										}}
									>
										<CreateRoundedIcon />
									</IconButton>
								</Tooltip>

								{/* <Tooltip title="Delete">
									<IconButton
										color="error"
										onClick={() => handleDelete(item.id)}
									>
										<DeleteIcon />
									</IconButton>
								</Tooltip> */}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</>
		);
	}

	const handleSubmit = (lkpValue, subLkpValue, lkpid) => {
		if (lkpValue === "" || lkpValue === "undefined") {
			return false;
		}
		var bodyFormData = new FormData();

		bodyFormData.append("authId", access);
		bodyFormData.append("category", lkpCat);
		bodyFormData.append("lkp_value", lkpValue);
		bodyFormData.append("sublkp_val", subLkpValue);
		bodyFormData.append("lkpId", lkpid);

		/**add photos */
		axios({
			method: "post",
			url: setLookupData,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 200) {
					toast(res_data.status_msg, "success");
					handleGetLookup();
					//return data
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	};

	const handleGetLookup = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		/**add photos */
		axios({
			method: "post",
			url: getLookupData,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 200) {
					setLookupList(res_data);
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	};


	const [finCodeList, setFinCodeList] = React.useState([]);
	console.log(finCodeList);

	const handleGetFinCodes = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		bodyFormData.append("pagination", false);      // pagination


		axios({
			method: "post",
			url: getFinList,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				const res_data = response.data;

				if (res_data.status_code === 200) {
					setFinCodeList(res_data.data);   // store API data
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	function handleDelete(deleteId) {
		var bodyFormData = new FormData();
		console.log(access);
		bodyFormData.append("authId", access);
		bodyFormData.append("id", deleteId);

		/**add photos */
		axios({
			method: "post",
			url: delLookupData,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				console.log(res_data);
				if (res_data.status_code === 200) {
					toast(res_data.status_msg, "success");
					setLookupList(res_data);
					handleGetLookup();
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	}
	const [addOpen, setAddOpen] = React.useState(false);



	const handleAddFinCode = () => {

		var bodyFormData = new FormData();

		bodyFormData.append("authId", access);
		bodyFormData.append("code", finCode);
		bodyFormData.append("description", subValue);
		bodyFormData.append("status", status);

		axios({
			method: "post",
			url: addFin,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {

				const res_data = response.data;

				if (res_data.status_code === 200) {
					setAddOpen(false);
					toast(res_data.status_msg, "success");
					handleGetFinCodes(); // refresh table
				} else {
					toast(res_data.status_msg, "error");
					console.log(res_data.status_msg);
				}

			})
			.catch(function (error) {
				console.log(error);
			});
	};

	const [open, setOpen] = React.useState(false);
	const [subValue, setSubValue] = React.useState("");
	const [status, setStatus] = React.useState("0");


	const handleUpdate = () => {

		var bodyFormData = new FormData();

		bodyFormData.append("authId", access);
		bodyFormData.append("id", selectedRowId);
		bodyFormData.append("code", finCode);
		bodyFormData.append("description", subValue);
		bodyFormData.append("status", status);

		axios({
			method: "post",
			url: editFinList,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {

				const res_data = response.data;

				if (res_data.status_code === 200) {
					setOpen(false);
					handleGetFinCodes(); // refresh table
				} else {
					console.log(res_data.status_msg);
				}

			})
			.catch(function (error) {
				console.log(error);
			});
	};

	React.useEffect(() => {
		handleGetLookup();
		handleGetFinCodes();
	}, []);

	return (
		<>
			<Container style={{ marginTop: "105px", width: "100%" }}>
				<ToastContainer />
				<Box
					sx={{ bgcolor: "background.paper" }}
					style={{ marginTop: "105px", width: "100%" }}
				>
					<AppBar position="static">
						<Tabs
							value={value}
							onChange={handleChange}
							indicatorColor="secondary"
							textColor="inherit"
							variant="scrollable"
							allowScrollButtonsMobile
							aria-label="full width tabs example"
						>
							<Tab label="Pipe Type" name="pipeType" {...a11yProps(0)} />

							<Tab
								label="Expansion Type"
								name="expansionType"
								{...a11yProps(1)}
							/>
							{/*<Tab label="Pipe Bend" name="pipeBend" {...a11yProps(2)}/>*/}
							<Tab
								label="End Plate Material"
								name="epMaterial"
								{...a11yProps(2)}
							/>
							<Tab label="End Plate Model" name="epModal" {...a11yProps(3)} />
							<Tab label="Orientation" name="oreientation" {...a11yProps(4)} />
							<Tab label="Cover Type" name="coverType" {...a11yProps(5)} />
							<Tab label="Cover Detail" name="coverDetail" {...a11yProps(6)} />
							<Tab
								label="Circuit Model"
								name="circuitModel"
								{...a11yProps(7)}
							/>
							<Tab label="Liquid Line" name="liquidLine" {...a11yProps(8)} />
							<Tab
								label="Discharge Line"
								name="dischargeLine"
								{...a11yProps(9)}
							/>
							<Tab label="Paint Type" name="paintType" {...a11yProps(10)} />
							<Tab label="Packing Type" name="packingType" {...a11yProps(11)} />
							<Tab
								label="Dispatch Mode"
								name="dispatchMode"
								{...a11yProps(12)}
							/>
							<Tab
								label="Brazing Lookup"
								name="brazingLkp"
								{...a11yProps(13)}
							/>
							<Tab
								label="CNC Master Program Model"
								name="cncMasterPmgLkp"
								{...a11yProps(14)}
							/>
							<Tab label="Fin Codes" name="pinType" {...a11yProps(15)} />
						</Tabs>
					</AppBar>
					<SwipeableViews
						axis={theme.direction === "rtl" ? "x-reverse" : "x"}
						index={value}
						onChangeIndex={handleChangeIndex}
					>
						<TabPanel value={value} index={0} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={0} />
						</TabPanel>
						<TabPanel value={value} index={1} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={1} />
						</TabPanel>
						<TabPanel value={value} index={2} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={2} />
						</TabPanel>
						<TabPanel value={value} index={3} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={3} />
						</TabPanel>
						<TabPanel value={value} index={4} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={4} />
						</TabPanel>
						<TabPanel value={value} index={5} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={5} />
						</TabPanel>
						<TabPanel value={value} index={6} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={6} />
						</TabPanel>
						<TabPanel value={value} index={7} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={7} />
						</TabPanel>
						<TabPanel value={value} index={8} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={8} />
						</TabPanel>
						<TabPanel value={value} index={9} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={9} />
						</TabPanel>
						<TabPanel value={value} index={10} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={10} />
						</TabPanel>
						<TabPanel value={value} index={11} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={11} />
						</TabPanel>
						<TabPanel value={value} index={12} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={12} />
						</TabPanel>
						<TabPanel value={value} index={13} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={13} />
						</TabPanel>
						<TabPanel value={value} index={14} dir={theme.direction}>
							<TabContent dataList={lookUpList} index={14} />
						</TabPanel>
						<TabPanel value={value} index={15} dir={theme.direction} >
							<Button
								variant="contained"
								onClick={() => {
									setFinCode("");
									setSubValue("");
									setStatus("0");
									setAddOpen(true);
								}}
								sx={{ mb: 3 }}
							>
								Add Fin Code
							</Button>
							<Table>
								<TableFins
									dataList={finCodeList}
									setSelectedRowId={setSelectedRowId}
									setFinCode={setFinCode}
									setSubValue={setSubValue}
									handleDelete={handleDelete}
									setStatus={setStatus}
								/>
							</Table>
						</TabPanel>
					</SwipeableViews>
				</Box>
				<div
					className="modal modal-lg fade"
					id="staticBackdrop"
					data-bs-backdrop="static"
					data-bs-keyboard="false"
					aria-labelledby="staticBackdropLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-headline" id="staticBackdropLabel">
									Edit Look Up Data
								</h5>
								<button
									type="button"
									className="btn-close"
									data-bs-dismiss="modal"
									aria-label="Close"
								></button>
							</div>
							<div className="modal-body">
								<Container>
									<Card>
										<h3>Update look up value</h3>
										<div className="row">
											{lkpCat !== "coverDetail" && (
												<div className="col-4">
													<TextField
														label="Look up Value"
														id="lkpvalue"
														name="lkpvalue"
														autoComplete="lkpvalue"
														required
														fullWidth
														value={editValue}
														onChange={(e) => {
															setEditValue(e.target.value);
														}}
													/>
												</div>
											)}
											{lkpCat === "coverDetail" && (
												<div className="row">
													<div className="col-4">
														<FormControl fullWidth>
															<InputLabel id="coverType-label">
																Cover Type
															</InputLabel>
															<Select
																labelId="coverType-label"
																id="coverType-select"
																label="Cover Type"
																value={editValue}
																onChange={(event) =>
																	setEditValue(event.target.value)
																}
															>
																{lookUpList["coverType"]?.map((item) => {
																	return (
																		<MenuItem value={item.id}>
																			{item.lkp_value}
																		</MenuItem>
																	);
																})}
															</Select>
														</FormControl>
													</div>
													<div className="col-4">
														<TextField
															label="Sub Look up Value"
															id="lkpvalue"
															name="lkpvalue"
															autoComplete="lkpvalue"
															required
															fullWidth
															value={editSubValue}
															onChange={(e) => setEditSubValue(e.target.value)}
														/>
													</div>
												</div>
											)}
											<div className="col-4">
												<Button
													type="submit"
													variant="contained"
													onClick={() =>
														handleSubmit(editValue, editSubValue, selectedRowId)
													}
												>
													Update
												</Button>
											</div>
										</div>
									</Card>
								</Container>
							</div>
						</div>
					</div>
				</div>

				<Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
					<DialogTitle>Edit Fin Code</DialogTitle>

					<DialogContent>
						<TextField
							label="Code"
							fullWidth
							margin="normal"
							value={finCode}
							onChange={(e) => {
								const value = e.target.value;
								if (/^[A-Za-z]*$/.test(value)) {
									setFinCode(value);
								}
							}}
						/>

						<TextField
							label="Description"
							fullWidth
							margin="normal"
							value={subValue}
							onChange={(e) => setSubValue(e.target.value)}
						/>

						<FormControl fullWidth margin="normal">
							<InputLabel>Status</InputLabel>
							<Select
								value={status}
								label="Status"
								onChange={(e) => setStatus(e.target.value)}
							>
								<MenuItem value="1">Active</MenuItem>
								<MenuItem value="0">Inactive</MenuItem>
							</Select>
						</FormControl>

					</DialogContent>

					<DialogActions>
						<Button onClick={() => setOpen(false)}>Cancel</Button>

						<Button
							variant="contained"
							onClick={handleUpdate}
						>
							Update
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog open={addOpen} onClose={() => setAddOpen(false)} fullWidth maxWidth="sm">
					<DialogTitle>Add Fin Code</DialogTitle>

					<DialogContent>

						<TextField
							label="Code"
							fullWidth
							margin="normal"
							value={finCode}
							onChange={(e) => {
								const value = e.target.value;
								if (/^[A-Za-z]*$/.test(value)) {
									setFinCode(value);
								}
							}}
						/>

						<TextField
							label="Description"
							fullWidth
							margin="normal"
							value={subValue}
							onChange={(e) => setSubValue(e.target.value)}
						/>

						<FormControl fullWidth margin="normal">
							<InputLabel>Status</InputLabel>
							<Select
								value={status}
								label="Status"
								onChange={(e) => setStatus(e.target.value)}
							>
								<MenuItem value="1">Active</MenuItem>
								<MenuItem value="0">Inactive</MenuItem>
							</Select>
						</FormControl>

					</DialogContent>

					<DialogActions>
						<Button onClick={() => setAddOpen(false)}>Cancel</Button>

						<Button
							variant="contained"
							onClick={handleAddFinCode}
						>
							Add
						</Button>
					</DialogActions>
				</Dialog>
			</Container>
		</>


	);
}
